import { Link } from "react-router-dom";

export default function Footer() {
  const footerLinks = [
    { name: "회사 소개", path: "/about" },
    { name: "브랜드", path: "/brand" },
    { name: "기술", path: "/technology" },
    { name: "공동체", path: "/community" },
    { name: "협력", path: "/partnership" },
  ];

  return (
    <footer className="bg-[#8B7355] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/c154a28dc0dac546d2890f3443561ccc.jpg"
                alt="Daygreen"
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold">Daygreen</span>
            </div>
            <p className="text-white/80 leading-relaxed max-w-md">
              기술로 자립하고, 존중으로 지속되는<br />
              지속가능한 산업을 만들어갑니다
            </p>
            <div className="mt-4 flex items-start gap-2 text-white/70 text-sm">
              <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
              <a
                href="https://www.google.com/maps/search/?api=1&query=대구시+중구+중앙대로+81길+96"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-white transition-colors cursor-pointer underline underline-offset-2 decoration-white/40 hover:decoration-white"
              >
                <strong className="text-white/90">본사</strong> 대구시 중구 중앙대로 81길 96, 201호
              </a>
            </div>
            <div className="mt-2 flex items-start gap-2 text-white/70 text-sm">
              <i className="ri-map-pin-2-line mt-0.5 flex-shrink-0"></i>
              <a
                href="https://www.google.com/maps/search/?api=1&query=대구시+달서구+두류남9길+17"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-white transition-colors cursor-pointer underline underline-offset-2 decoration-white/40 hover:decoration-white"
              >
                <strong className="text-white/90">공장</strong> 대구시 달서구 두류남9길 17, 304호
              </a>
            </div>
            <div className="mt-2 flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-phone-line flex-shrink-0"></i>
              <span>053-427-3082</span>
            </div>
            <div className="mt-2 flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-mail-line flex-shrink-0"></i>
              <a href="mailto:daygreen3082@naver.com" className="hover:text-white transition-colors">daygreen3082@naver.com</a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">메뉴</h3>
            <div className="grid grid-cols-2 gap-4">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white/80 hover:text-white transition-colors whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <p className="text-white/60 text-sm text-center">
            © 2024 Daygreen. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}